// Local translations
export const T = {
  en_GB: {
    addLine: "Add instrument",
    searchProducts: "Search products…",
    noProducts: "No product is available on every selected platform.",
    noResults: "No product matches.",
    instrument: "Instrument",
    isin: "ISIN",
    weight: "Weight %",
    min: "Min %",
    default: "Default %",
    max: "Max %",
    remove: "Remove",
    total: "Total",
    sumMin: "Σ min",
    sumMax: "Σ max",
    noLines: "No instruments yet — add the products the mandate permits.",
    notOnPlatform: "Not on every selected platform",
  },
  nb_NO: {
    addLine: "Legg til instrument",
    searchProducts: "Søk produkter…",
    noProducts: "Ingen produkter er tilgjengelige på alle valgte plattformer.",
    noResults: "Ingen produkter samsvarer.",
    instrument: "Instrument",
    isin: "ISIN",
    weight: "Vekt %",
    min: "Min %",
    default: "Standard %",
    max: "Maks %",
    remove: "Fjern",
    total: "Totalt",
    sumMin: "Σ min",
    sumMax: "Σ maks",
    noLines: "Ingen instrumenter ennå — legg til produktene mandatet tillater.",
    notOnPlatform: "Ikke på alle valgte plattformer",
  },
} as const;
